export default __webpack_public_path__ + "static/media/shopping.81587ab6.png";